// extracted by mini-css-extract-plugin
export default {"subtext-color":"subtextColor_subtext-color__LVzUp","subtext-color--secondary":"subtextColor_subtext-color--secondary__YGh46"};